<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ScrollRow from "../ScrollRow.vue";
import ToneItem from "./ToneItem.vue";
import CustomItem from "../CustomItem.vue";
import StarsAnimation from "@/components/StarsAnimation.vue";

const store = useStore();

const addTone = (tone) => store.dispatch("tone/addTone", tone);

const loading = computed(() => store.state.tone.loading);
</script>

<template>
  <section id="shepherd-target-tone">
    <div class="mb-6 flex flex-col lg:mb-8">
      <p class="mb-4 text-base font-bold text-primary">Tone</p>
      <ScrollRow>
        <ToneItem />
        <div
          v-if="loading"
          class="bg-gray-10 flex flex-col items-center justify-center w-24 h-24 mr-4 rounded-lg cursor-pointer"
        >
          <StarsAnimation :width="96" />
        </div>
        <CustomItem
          v-else
          :itemType="'tone'"
          @submit="addTone({ tone: $event, emoji: '📝' })"
        />
      </ScrollRow>
    </div>
  </section>
</template>
